module.exports = __webpack_public_path__ + "img/TAC_6000_R.51e838c0.png";